<template>
  <div id="login">
    <div class="left">
      <div class="left_main">
        <div class="left_logo">
          <img src="../assets/login/logo.png" />
        </div>
        <div class="left_bg">
          <img src="../assets/login/bg.jpg" />
        </div>
      </div>
    </div>
    <div class="right">
      <div class="login">
        <div class="title">欢迎登录</div>
        <div class="contain" style="position: relative">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100"
            style="padding: 20px"
          >
            <div class="all_font">账号</div>
            <el-form-item prop="user">
              <el-input
                placeholder="请输入账号"
                v-model="ruleForm.user"
                class="all-input"
                type="text"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <div class="all_font">密码</div>
            <el-form-item prop="pwd">
              <el-input
                placeholder="密码"
                type="password"
                v-model="ruleForm.pwd"
                autocomplete="off"
                class="all-input"
                show-password
                @keyup.enter.native="submitForm('ruleForm'), loginIn"
              ></el-input>
            </el-form-item>
            <div class="all_font">验证码</div>
            <!-- 验证码 -->
            <el-form-item prop="code">
              <el-input
                style="width: 65%"
                placeholder="请输入验证码"
                v-model="ruleForm.code"
                class="all-input-yzm"
              ></el-input>
              <div class="yzm" style="width: 35%" @click="changecodeurl()">
                <img class="img-height" style="width: 90%" :src="codeUrl" />
              </div>
            </el-form-item>
            <div class="flex-box">
              <el-checkbox v-model="rememberpwd">记住密码</el-checkbox>
              <el-button
                type="primary"
                style="width: 30%; float: right"
                @click="ToScanLogin()"
                >扫码登录
              </el-button>
            </div>
            <el-button
              class="login-btn"
              :loading="requestStatus"
              :plain="true"
              type="primary"
              style="width: 100%; margin-bottom: 30px"
              @click="submitForm('ruleForm'), loginIn"
              >登录
            </el-button>
            <div class="old">
              <a href="http://glxt.ntlawyer.cc:8080/" style="color: #027aff"
                >老系统入口</a
              >
            </div>
          </el-form>
          <div
            v-if="loginMode == 2"
            style="
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0px;
              top: 0px;
              backdrop-filter: blur(10px);
              z-index: 999;
              text-align: center;
            "
          >
            <div
              id="qrcode"
              style="
                width: 180px;
                height: 180px;
                position: relative;
                display: block;
                margin: 20px auto;
              "
            ></div>
            <el-button type="primary" style="width: 30%" @click="ToPassLogin()"
              >账号密码登录
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import QRCode from 'qrcodejs2'
import { nanoid } from 'nanoid'
import { getCode, loginApi, loginByCode, changePassword } from '../api/login.js'
export default {
  name: 'Login',
  data() {
    // 密码验证
    // 密码验证
    var checkpwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      //let regpwd = /^[a-zA-Z0-9_-]{6,16}$/;
      let regpwd = value.length
      setTimeout(() => {
        if (regpwd < 6 || regpwd > 16) {
          callback(new Error('请输入6到16的密码'))
        } else {
          callback()
        }
      }, 500)
    }
    // 用户名验证
    // var checkuser = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('用户名不能为空'))
    //   }
    //   let reguser = /^[a-zA-Z0-9_-]{4,16}$/
    //   setTimeout(() => {
    //     if (!reguser.test(value)) {
    //       callback(new Error('请输入4到16的用户名'))
    //     } else {
    //       callback()
    //     }
    //   }, 500)
    // }
    // 验证码验证
    var checkcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      } else {
        callback()
      }
    }
    return {
      rememberpwd: false,
      ruleForm: {
        user: '',
        pwd: '',
        code: ''
      },
      rules: {
        user: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pwd: [{ trigger: 'blur', validator: checkpwd }],
        // 验证码判断
        code: [{ trigger: 'blur', validator: checkcode }]
      },
      codeImg: '',
      dcode: '',
      scode: '',
      xh: null,
      qrobj: null,
      loginMode: 1,
      requestStatus: false,
      loginbg: {
        backgroundImage: 'url(' + require('../assets/bg.png') + ')'
      },
      codeUrl: '/api/pc/User/VerificationCode?key=' + Math.random()
    }
  },
  created() {
    this.savePwd()
    this.dcode = nanoid()
  },
  mounted() {
    // this.getCode();
    // Enter
    window.addEventListener('keydown', this.loginIn)
  },
  destroyed() {
    window.removeEventListener('keydown', this.loginIn, false)
  },
  methods: {
    // 记住密码
    savePwd() {
      if (
        localStorage.getItem('user1') != '' &&
        localStorage.getItem('pwd1') != ''
      ) {
        this.ruleForm.user = localStorage.getItem('user1')
        this.ruleForm.pwd = localStorage.getItem('pwd1')
        this.rememberpwd = true
      }
    },
    // 切换验证码
    changecodeurl() {
      this.codeUrl = '/api/pc/User/VerificationCode?key=' + Math.random()
    },
    // 登录方法封装
    loginFun() {
      // 添加按钮loading
      this.requestStatus = true
      // 获取公共参数
      let Params = {
        checkcode: this.ruleForm.code,
        password: this.ruleForm.pwd,
        username: this.ruleForm.user
      }
      //发送登录请求
      loginApi(Params)
        .then((res) => {
          if (res.data.status === 'success') {
            //记住密码
            if (this.rememberpwd == true) {
              localStorage.setItem('user1', this.ruleForm.user)
              localStorage.setItem('pwd1', this.ruleForm.pwd)
            } else {
              localStorage.removeItem('user1')
              localStorage.removeItem('pwd1')
            }
            this.requestStatus = true
            //存token
            window.sessionStorage.setItem('token', res.data.data.token)
            window.sessionStorage.setItem('userId', res.data.data.uid)
            window.sessionStorage.setItem('userstatus', res.data.data.status)
            // 登录用户赋值
            this.$store.commit('loginName', res.data.data.nikename)
            this.$router.push('/home')
            this.$message({
              message: '登录成功',
              type: 'success',
              duration: 1000
            })
          } else if (
            res.data.message == '登录失败，验证码错误。' ||
            res.data.message == '登录失败，验证码无效。'
          ) {
            this.$message.error(res.data.message)
            this.changecodeurl()
            this.ruleForm.code=""
          } else {
            this.$message.error(res.data.message)
            this.changecodeurl()
            this.ruleForm.code=""
          }
          // 消除按钮loading
          this.requestStatus = false
        })
        .catch((e) => {
          this.$message.error(e)
          this.codeUrl = '/api/pc/User/VerificationCode?key=' + Math.random()
          this.ruleForm.code = ''
          this.requestStatus = false
        })
      // window.sessionStorage.setItem("token", "1234456");
      // // this.$store.commit("setRoles", ["admin"]);
      // this.$router.push("/home");
      // this.$message({ message: "登录成功", type: "success" });
    },

    //登录按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // localStorage.setItem("menustatus", "0"),
          // 调用登录接口
          this.loginFun()
        } else {
          return false
        }
      })
    },
    // Enter
    loginIn() {
      let keyCode = window.event.keyCode

      if (keyCode == 13 && this.$route.path == '/login') {
        this.submitForm('ruleForm')
      } else {
        return
      }
    },
    //切换到扫码登陆
    ToScanLogin() {
      this.loginMode = 2
      this.scode = ''
      this.PostSc()
    },
    ToPassLogin() {
      this.loginMode = 1
      clearTimeout(this.xh)
      this.dcode = nanoid()
      this.scode = ''
      this.qrobj = null
    },
    PostSc() {
      loginByCode({ dcode: this.dcode, scode: this.scode }).then((res) => {
        if (res.data.status == 'code success') {
          this.scode = res.data.data
          console.log('sc_xtl_' + this.scode)

          if (this.qrobj == null) {
            this.qrobj = new QRCode(document.getElementById('qrcode'), {
              text: 'sc_xtl_' + this.scode,
              width: 180,
              height: 180,
              colorDark: '#000000',
              colorLight: '#ffffff'
            })
          } else {
            this.qrobj.makeCode('sc_xtl_' + this.scode)
          }
          this.xh = setTimeout(this.PostSc, 1500)
        } else if (res.data.status == 'code wait') {
          this.xh = setTimeout(this.PostSc, 1500)
        } else if (res.data.status == 'code removed') {
          this.dcode = nanoid()
          this.scode = ''
        } else if (res.data.status == 'success') {
          clearTimeout(this.xh)
          //存token
          window.sessionStorage.setItem('token', res.data.data.token)
          window.sessionStorage.setItem('userId', res.data.data.uid)
          // 登录用户赋值
          this.$store.commit('loginName', res.data.data.nikename)
          this.$router.push('/home')
          this.$message({
            message: '登录成功',
            type: 'success',
            duration: 1000
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;
  ::v-deep .el-input__validateIcon {
    display: none;
  }
}
.old {
  color: #027aff;
  font-size: 14px;
  text-align: right;
  margin-top: -8px;
  cursor: pointer;
}
.left {
  width: 50%;
  float: left;
  // background-image: url(../assets/logo.png);
  background: #3077e6;
  height: 100%;
  display: flex;
}
.left_main {
  width: 80%;
  margin: auto;
}
.left_main img {
  width: 100%;
  height: 100%;
}
.left_logo {
  width: 70%;
  margin: auto;
}
.left_bg {
  width: 100%;
  margin: auto;
  margin-top: 80px;
}
.right {
  width: 50%;
  height: 100%;
  float: right;
  display: flex;
}
.login {
  display: flex;
  justify-content: center;
  flex-direction: column;

  margin: 8% auto;
  width: 45%;

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #3077e6;
    line-height: 29px;
    font-family: 'Roboto';
  }
  .contain {
    margin-top: 30px;
  }
  .all_font {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #027aff;
    margin-bottom: 15px;
  }
  .yzm {
    float: right;
    width: 40%;
    .img-height {
      height: 45px;
      float: right;
    }
  }
  ::v-deep .all-input .el-input__inner {
    height: 45px;
  }
  ::v-deep .all-input-yzm .el-input__inner {
    height: 45px;
  }
  .all-input-yzm {
    float: left;
    width: 60%;
  }
  .login-btn {
    margin-top: 30px;
    height: 45px;
    background-color: #027aff;
    color: #fff;
  }
}
</style>
